import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface FieldsInputTitleProps {
  label: string | undefined;
  isRequired?: boolean;
}

export const FieldsInputTitle: React.FC<FieldsInputTitleProps> = ({
  label,
  isRequired = false,
}) => {
  const theme = useTheme();

  return (
    <Typography variant="subtitle2">
      {label}{' '}
      {isRequired && <span style={{ color: theme.palette.error.main }}>*</span>}
    </Typography>
  );
};
